<template>
  <div>
    <CCard>
      <CCardHeader>
        <CampaignViewHeader
          title="Data Analysis"
          :disable-member-select="!selected_member || is_loading"
          :selected-member-id="selected_member"
          :update-member-id-function="changeMember"
        />
      </CCardHeader>
      <CCardBody>
        <DotsLoader v-if="is_loading"/>
        <template v-else>
          <CRow>
            <CCol col="3">
              <label>GP CCR:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="min-width: 200px"
                v-model="selected_group_ccr"
              />
            </CCol>
            <CCol col="3">
              <label>Code CPT:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="min-width: 200px"
                v-model="selected_code_cpt"
              />
            </CCol>
            <CCol col="3">
              <label> code GTA:</label>
              <CInput
                :disabled="true"
                class="mr-2"
                style="min-width: 200px"
                v-model="selected_code_gda"
              />
            </CCol>
            <CCol class="text-right">
              <CButton
                class="mz-button v2-mz-btn mr-2 mt-3"
                color="primary"
                @click="
                  $downloadFile({
                    url: download_url
                  })
                ">
                {{ $t('Download') }}
              </CButton>
            </CCol>
          </CRow>
          <CRow class="mt-5 mb-2 w-100">
            <CCol
              v-for="nav_item in nav_items"
              class="text-center"
              :key="nav_item.name"
            >
              <div
                :class="{'custom-border-bottom': isCurrentPage(nav_item)}"
                class="mt-3 on-mouse-hover"
                @click="switchPage(nav_item)"
              >
                <h5>
                  {{ $t(`${nav_item.name}`) }}
                </h5>
              </div>
            </CCol>
          </CRow>
          <CRow class="w-100 mt-3">
            <template v-if="selected_nav === 'risk_file_i_and_annex_ii'">
              <DotsLoader class="reset-margin" v-if="table_loading"/>
              <div v-else class="w-100">
                <CRow class="w-100">
                  <CCol col="12" class="text-center mt-1 mb-3 text-danger">
                    <i class="fa fa-exclamation-triangle" />
                    {{ $t("Prior to being able to view risk file analyses, it is necessary to first assign insurance branches") }}
                  </CCol>
                </CRow>
                <table-component
                  :show-number-of-lines="false"
                  :display-columns-selector="false"
                  :columns="Object.keys(risk_file_i_and_annex_ii_headings)"
                  :headings="risk_file_i_and_annex_ii_headings"
                  :data="analysis_data"
                >

                  <template slot="line_of_business" slot-scope="{row}">
                    {{ $store.state.language === 'en' ? row.EN : row.branch }}
                  </template>

                  <template
                      v-for="item in Object.keys(risk_file_i_and_annex_ii_headings).filter(k => !['line_of_business', 'department'].includes(k))"
                      :slot="item" slot-scope="{row}"
                  >
                    <div class="text-right">
                      {{ $getNumericalValue(row[`${item}`], 0) }}
                    </div>
                  </template>

                </table-component>
              </div>
            </template>

            <template v-if="selected_nav === 'annex_i_and_annex_ii'">
              <DotsLoader class="reset-margin" v-if="table_loading"/>
              <div v-else class="w-100">
                <table-component
                  :show-number-of-lines="false"
                  :display-columns-selector="false"
                  :columns="Object.keys(ann_i_and_ann_ii_headings)"
                  :headings="ann_i_and_ann_ii_headings"
                  :data="analysis_data"
                >
                  <template slot="line_of_business" slot-scope="{row}">
                    {{ $store.state.language === 'en' ? row.EN : row.branch }}
                  </template>

                  <template v-for="item in Object.keys(ann_i_and_ann_ii_headings).filter(k => k !== 'line_of_business')" :slot="item" slot-scope="{row}">
                    <div class="text-right">
                      {{ $getNumericalValue(row[`${item}`], 0) }}
                    </div>
                  </template>

                </table-component>
              </div>
            </template>

            <template v-if="selected_nav === 'annex_i_and_annex_iii'">
              <DotsLoader class="reset-margin" v-if="table_loading"/>
              <div v-else class="w-100">
                <table-component
                  :show-number-of-lines="false"
                  :display-columns-selector="false"
                  :columns="Object.keys(annex_i_and_annex_iii_headings)"
                  :headings="annex_i_and_annex_iii_headings"
                  :data="analysis_data"
                >

                  <template slot="line_of_business" slot-scope="{row}">
                    {{ $store.state.language === 'en' ? row.EN : row.branch }}
                  </template>

                  <template v-for="item in Object.keys(annex_i_and_annex_iii_headings).filter(k => k !== 'line_of_business')" :slot="item" slot-scope="{row}">
                    <div class="text-right">
                       {{  $getNumericalValue(row[`${item}`], 0) }}
                    </div>
                  </template>

                </table-component>
              </div>
            </template>

            <template v-if="selected_nav === 'annex_evolution'">
              <DotsLoader class="reset-margin" v-if="table_loading"/>
              <div v-else v-for="(data, index) in analysis_data" class="mt-2 w-100">
                <label class="ml-2">
                  <h4>{{ $t(`${ann_title[index]}`) }}</h4>
                </label>
                <table-component
                  :show-number-of-lines="false"
                  :display-columns-selector="false"
                  :columns="Object.keys(index === 1 ? annex_ii_evolution_headings : annex_evolution_headings)"
                  :headings="index === 1 ? annex_ii_evolution_headings : annex_evolution_headings"
                  :data="data"
                >

                  <template slot="line_of_business" slot-scope="{row}">
                    <div>
                      {{ $store.state.language === 'en' ? row.EN : row.branch }}
                    </div>
                  </template>

                  <template
                      v-for="item in Object.keys(index === 1 ? annex_ii_evolution_headings : annex_evolution_headings).filter(k => k !== 'line_of_business')"
                      :slot="item" slot-scope="{row}"
                  >
                    <div
                        v-if="item.includes('evolution')"
                        class="text-right"
                    >
                      {{ returnNumberWithTwoDecimal(row[`${item}`]) }}%
                    </div>
                    <div v-else class="text-right">
                      {{ $getNumericalValue(row[`${item}`], 0) }}
                    </div>
                  </template>

                </table-component>
              </div>
            </template>
          </CRow>
        </template>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import CampaignViewHeader from "@/components/CampaignViewHeader";
import {AnalysisService, ANALYSIS_ENDPOINTS} from "@/services/analysis";
import {MemberService} from "@/services/members";
import {CampaignServices} from "@/services/campaigns";
import {ActiveUser} from "@/services/user";


export default {
  name: "AnalysisView",
  components: {CampaignViewHeader},
  data() {
    return {
      campaignId: this.$route.params.campaignId,
      campaignMemberId: this.$route.params.id,
      is_loading: false,
      table_loading: false,
      members_options: [],
      selected_member: '',
      analysis_data: [],
      download_url: '',
      userData: ActiveUser.get(),
      campaign_member: {},
      selected_nav: '',
      risk_file_i_and_annex_ii_headings: {
        department: this.$t('Department'),
        line_of_business: this.$t('Line of Business'),
        risk_insured_sums: this.$t('Insured Sums (Risk)'),
        annexe_ii_insured_sums: this.$t('Insured Sums (Annexe II)'),
        difference_insured_sums: this.$t('Difference insured sums'),
        risk_issued_prime: this.$t('Premiums (risk)'),
        annexe_ii_issued_prime: this.$t('Premiums (Appendix II)'),
        difference_premiums: this.$t('Difference premiums'),
        risk_police_number: this.$t('Number of polices (risk)'),
        annexe_ii_police_number: this.$t('Number of polices (Appendix II)'),
        difference_police_numbers: this.$t('Difference police number'),
      },
      ann_i_and_ann_ii_headings: {
        line_of_business: this.$t('Line of Business'),
        annexe_i_issued_prime: this.$t('Premiums (Appendix I)'),
        annexe_ii_issued_prime: this.$t('Premiums (Appendix II)'),
        difference_premiums: this.$t('Difference premiums'),
        annexe_i_police_number: this.$t('Number of polices (Appendix I)'),
        annexe_ii_police_number: this.$t('Number of polices (Appendix II)'),
        difference_police_numbers: this.$t('Difference police number'),
      },
      annex_i_and_annex_iii_headings: {
        line_of_business: this.$t('Line of Business'),
        annexe_iii_issued_prime: this.$t('Estimated premiums (Appendix III)'),
        annexe_i_issued_prime: this.$t('Premiums (Appendix I)'),
        difference_premiums: this.$t('Difference premiums'),
        annexe_iii_police_number: this.$t('Number of polices (Appendix III)'),
        annexe_i_police_number: this.$t('Number of polices (Appendix I)'),
        difference_police_numbers: this.$t('Difference police number')
      },
      annex_evolution_headings: {
        line_of_business: this.$t('Line of Business'),
        current_issued_prime: `${this.$t('Premiums')} (n)`,
        previous_issued_prime: `${this.$t('Premiums')} (n-1)`,
        evolution_prime: '% evolution',
        current_police_number: `${this.$t('Number of polices')} (n)`,
        previous_police_number: `${this.$t('Number of polices')} (n-1)`,
        evolution_police: '% evolution'
      },
      annex_ii_evolution_headings: {
        line_of_business: this.$t('Line of Business'),
        current_issued_prime: `${this.$t('Premiums')} (n)`,
        previous_issued_prime: `${this.$t('Premiums')} (n-1)`,
        evolution_prime: '% evolution',
        current_issued_sum: `${this.$t('Insured sum')} (n)`,
        previous_issued_sum: `${this.$t('Insured sum')} (n-1)`,
        evolution_insured_sum: '% evolution',
        current_police_number: `${this.$t('Number of polices')} (n)`,
        previous_police_number: `${this.$t('Number of polices')} (n-1)`,
        evolution_police: '% evolution'
      },
      nav_items: [
        {
          value: 'risk_file_i_and_annex_ii',
          name: 'Risk File I and Appendix II'
        },
        {
          value: 'annex_i_and_annex_ii',
          name: 'Appendix I and Appendix II'
        },
        {
          value: 'annex_i_and_annex_iii',
          name: 'Appendix I and Appendix III'
        },
        {
          value: 'annex_evolution',
          name: 'Appendix evolution'
        },
      ],
      ann_title: ["Appendix I", "Appendix II", "Appendix III"],
    }
  },
  computed: {
    selected_code_cpt() {
      return this.members_options.find(member => member.value === this.selected_member)?.code_cpt;
    },
    selected_code_gda() {
      return this.members_options.find(member => member.value === this.selected_member)?.code_gda;
    },
    selected_group_ccr() {
      return this.campaign_member?.group_ccr || ""
    },

  },
  async mounted() {
    this.is_loading = true;
    const members = await MemberService.getMembers()
    this.members_options = members.map((member) => ({
      value: member.id_member,
      label: member.name,
      code_cpt: member.code_cpt,
      code_gda: member.code_gda,
    }));
    this.selected_member = Number(this.$route.params.id)
    const {data} = await CampaignServices.fetchCampaignMember(this.$route.params.campaignId, this.$route.params.id)
    this.campaign_member = data

    const tab = this.$route.query?.tab || ''
    if (tab) await this.switchPage({ value: tab });
    else await this.switchPage(this.nav_items[0]);
    this.is_loading = false;
  },
  methods: {
    consoleLog(row) {
      console.log("SADASDSADSA")
      console.log(row)
    },
    isCurrentPage(nav_item) {
      return this.selected_nav === nav_item.value
    },
    changeMember(member_id) {
      this.$router.push({name: 'Data Analysis', params: {campaignId: this.campaignId, id: member_id}})
    },
    returnNumberWithTwoDecimal(value) {
      return value.toFixed(2);
    },
    async getUrl() {
      switch (this.selected_nav) {
        case "risk_file_i_and_annex_ii":
          this.download_url = ANALYSIS_ENDPOINTS.compare_riskfile_and_annexeii_download(
            this.campaignId, this.campaignMemberId)

          return await AnalysisService.getCompareRiskFileAndAnnexeII(this.campaignId, this.campaignMemberId)
        case "annex_i_and_annex_ii":
          this.download_url = ANALYSIS_ENDPOINTS.compare_annexei_and_annexeii_download(
            this.campaignId, this.campaignMemberId)

          return await AnalysisService.getCompareAnnexeIAndAnnexeII(this.campaignId, this.campaignMemberId);
        case "annex_i_and_annex_iii":
          this.download_url = ANALYSIS_ENDPOINTS.compare_annexei_and_annexeiii_download(
            this.campaignId, this.campaignMemberId)

          return await AnalysisService.getCompareAnnexeIAndAnnexeIII(this.campaignId, this.campaignMemberId);
        case "annex_evolution":
          this.download_url = ANALYSIS_ENDPOINTS.evolution_of_annex_download(this.campaignId, this.campaignMemberId);

          return await AnalysisService.getEvolutionOfAnnex(this.campaignId, this.campaignMemberId)
      }
    },
    async fetchAnalysisData() {
      this.analysis_data = await this.getUrl();
    },
    async switchPage(nav_item) {
      this.table_loading = true;
      this.$router.replace({ query: { tab: nav_item.value } })
      this.selected_nav = nav_item.value
      await this.fetchAnalysisData();
      this.table_loading = false;
    },
  },
}
</script>
<style scoped>
.reset-margin {
  margin: 3rem auto 0;
}
.custom-border-bottom {
  border-bottom: 2px solid #23145f;
}

.on-mouse-hover:hover {
  cursor: pointer;
}
</style>
